module.exports = __webpack_public_path__ + "img/sticker_19.8688daf5.svg";